export const ELLIPSIS = '\u2026';
const ellipsisLength = ELLIPSIS.length;

/**
 * Cuts off a string and adds an ellipsis if it exceeds the max length
 * @param s string
 * @param max (even or add number)
 */
export function doEllipsisCutoff(s: string, max?: number | null): [string, boolean] {
    if (max === undefined || max === null) return [s, false];
    if (max === 0) return ['', s !== ''];
    if (max === 1) {
        if (s.length === 1) return [s, false];
        return [ELLIPSIS, true];
    }
    if (s.length > max) {
        const max1 = Math.floor((max - ellipsisLength) / 2);
        const max2 = Math.ceil((max - ellipsisLength) / 2);
        const start = s.substring(0, max2);
        const end = s.substring(s.length - max1);
        return [`${start}${ELLIPSIS}${end}`, true];
    } else {
        return [s, false];
    }
}

export function isStingArrayKindOfTable(values: string[], commonKeyThreshold = 0.6): boolean {
    if (values.some(v => v.split(':').length < 3)) return false;
    const collective_keys = new Set(values.flatMap(value =>
        value.split(',').length > 1
            ? value.split(',').map(kv =>
                kv.split(':').length === 2
                    ? kv.split(':')[0]
                    : '')
            : ['']));
    if (collective_keys.size === 0) return false;
    return values.every(value => {
        const value_keys = value.split(',').map(kv =>
            kv.split(':').length === 2
                ? kv.split(':')[0]
                : '');
        return (value_keys.length / collective_keys.size) >= commonKeyThreshold;
    });
}

/**
 * Trims a certain substring from a string
 * @param s string to trim from
 * @param subString substring to trim
 */
export function strTrim(s: string, subString: string): string {
    while (s.startsWith(subString)) {
        s = s.substring(subString.length);
    }
    while (s.endsWith(subString)) {
        s = s.substring(0, s.length - subString.length);
    }
    return s;
}
